import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";

export default class DynamicTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wszystkieKolumnyEksport: [],
            kolumnyDoExportuDefault: []
        };
    }

    componentDidMount() {
        this.przygotujKolumnyDoExportu();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.przygotujKolumnyDoExportu();
        }
    }

    przygotujKolumnyDoExportu = () => {
        if (this.props.data && this.props.data.length > 0) {
            const kolumny = Object.keys(this.props.data[0]).map(key => ({
                value: key,
                label: this.formatujNazweKolumny(key)
            }));

            this.setState({
                wszystkieKolumnyEksport: kolumny,
                kolumnyDoExportuDefault: kolumny
            });
        } else {
            this.setState({
                wszystkieKolumnyEksport: [],
                kolumnyDoExportuDefault: []
            });
        }
    }

    formatujNazweKolumny = (key) => {
        // Zamienia klucze z camelCase lub snake_case na czytelne nazwy
        return key
            .replace(/_/g, ' ')
            .replace(/([A-Z])/g, ' $1')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ')
            .trim();
    }

    pobierzTypKolumny = (key, value) => {
        // Określa typ danych w kolumnie
        if (typeof value === 'number') {
            return 'number';
        }
        return 'text';
    }

    renderujKolumny = () => {
        if (!this.props.data || this.props.data.length === 0) {
            return (
                <TableHeaderColumn
                    dataField='placeholder'
                    isKey
                >
                    Brak danych
                </TableHeaderColumn>
            );
        }

        const firstRow = this.props.data[0];
        const keys = Object.keys(firstRow);

        return keys.map((key, index) => {
            const typDanych = this.pobierzTypKolumny(key, firstRow[key]);
            const filterType = typDanych === 'number' ? 'NumberFilter' : 'TextFilter';
            const isKey = index === 0; // Pierwszy klucz jako główny key dla tabeli

            return (
                <TableHeaderColumn
                    key={key}
                    dataField={key}
                    isKey={isKey}
                    dataSort
                    thStyle={tabgrid.tg3}
                    tdStyle={tabgrid.tg3}
                    filter={{type: filterType, delay: 500, placeholder: 'Szukaj'}}
                >
                    {this.formatujNazweKolumny(key)}
                </TableHeaderColumn>
            );
        });
    }

    render() {
        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
        };

        return (
            <div>
                <div>
                    {this.props.data && this.props.data.length > 0 && (
                        <TopExportCSV
                            daneRest={this.props.data}
                            wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                            kolumnyDoExportu={this.state.kolumnyDoExportuDefault}
                        />
                    )}
                </div>
                <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                    Ilość wszystkich rekordów: {this.props.data ? this.props.data.length : 0}
                </div>
                <div>
                    <BootstrapTable
                        data={this.props.data || []}
                        options={options}
                        pagination
                        hover
                    >
                        {this.renderujKolumny()}
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/raporty/Ksiegowosc/components/DynamicTable.js